import { useMemo } from 'react';

import Icon from 'components/global/Icon';
import LottiePlayer from 'components/global/LottiePlayer';
import Typography from 'components/global/Typography';

import { faCircleX } from '@fortawesome/pro-light-svg-icons';

import * as S from './OTOLinkBuyer.styled';

export const ERROR_TYPES = {
	EXPIRED: 'error.L016',
	KEY_NOT_FOUND: 'error.L018',
	INACTIVE_LINK: 'inactive_link'
};

const OTOLinkError = ({ errorCode }) => {
	const renderError = useMemo(() => {
		switch (errorCode) {
			case ERROR_TYPES.EXPIRED:
				return <LinkExpiry />;
			case ERROR_TYPES.KEY_NOT_FOUND:
				return <LinkNotFound />;
			case ERROR_TYPES.INACTIVE_LINK:
				return <LinkNotFound />;
			default:
				return <LinkNotFound />;
		}
	}, [errorCode]);

	return (
		<S.ResultContainer>
			<S.Card padding={0} background border={0} shadowed rounded>
				<S.ErrorWrapper>{renderError}</S.ErrorWrapper>
			</S.Card>
		</S.ResultContainer>
	);
};

const LinkExpiry = () => (
	<S.ErrorInfoContainer>
		<Icon icon={faCircleX} color={'var(--red)'} fontSize="10rem" />
		<Typography variant="h4" fontWeight="500">
			otoLinkExpiredTitle
		</Typography>
		<Typography color="var(--content-3)" fontWeight="500" noWrap>
			oToLinkExpiredDescription
		</Typography>
	</S.ErrorInfoContainer>
);

const LinkNotFound = () => (
	<>
		<LottiePlayer name="not-found-sms" width="30rem" height="auto" />
		<S.ErrorInfoContainer>
			<Typography variant="h4" fontWeight="500">
				otoLinkNotFoundTitle
			</Typography>
			<Typography color="var(--content-3)" fontWeight="500" noWrap>
				otoLinkNotFoundDescription
			</Typography>
		</S.ErrorInfoContainer>
	</>
);

export default OTOLinkError;
